import React from 'react'

function Email() {
  return (
    <div>Email</div>
  )
}

export default Email